import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TableData } from 'utils/data'

export const fetchTargetCircle = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
